// src/components/ProductSelection.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Chip,
  Container,
  IconButton,
  Stack,
  Tooltip,
  Popover,
} from '@mui/material';
import { getSkuDetails } from '../../screen/auth/action/util_actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetProductsWithSkuDetails,
  getOrderCostAction,
} from '../../screen/auth/action';

import { useLocation, useNavigate } from 'react-router-dom';
import { formType, manufacturer_company_type, OperationType, skuKeys } from '../../utils/settings';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Delete } from '@mui/icons-material';
import AddRemoveQty from '../Components/AddRemoveQty';
import MouseOverPopover from '../MyAccount/Container/HoverPopover';
const AddProduct = () => {
  const [steelProdFilters, setSteelProdFilters] = useState({
    GRADE: null,
    FORM_TYPE: null,
    // dia: null,
  });
  const [skuGrades, setSkuGrades] = useState([]);
  const [isSteelCompany, setIsSteelCompany] = useState(false);
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [skuFormTypes, setSkuFormTypes] = useState([]);
  const [selectedProductList, setSelectedProductList] = useState([]);
  const { state } = useLocation();
  const [totalCost, setTotalCost] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isFromEditOrderDetails = false, ship_to_party_id = null } = state;

  const { Text, Title } = Typography;

  const [skuData, setSkuData] = useState({
    type_id: 0,
    grade_id: 0,
    sub_grade_id: 0,
    nb_id: 0,
    od_id: 0,
    area_id: 0,
    coating_id: 0,
    thickness_id: 0,
    length_id: 0,
  });
  const SelectedFormType = skuFormTypes.find(form => form.sku_value_id === steelProdFilters.FORM_TYPE)?.sku_value
        
  const handleAdd = () => {
    if (!selectedProduct.qty || selectedProduct.qty === 0)
      return toast.error('Please enter valid quantity.');

    if (!selectedProduct.product_id)
      return toast.error('Please Select Product');

    if (selectedProduct) {
      if (state?.isFromEditOrderDetails) {
        selectedProduct.operation_type = OperationType['ADD'];
      }
      selectedProduct.form_type = formType[SelectedFormType];
      const index = selectedProductList.findIndex(
        (item) => item.product_id === selectedProduct.product_id,
      );

      if (index !== -1) {
        const tempList = [...selectedProductList];
        tempList[index].qty =
          Number(tempList[index].qty) + Number(selectedProduct.qty);
        setSelectedProductList(tempList);
      } else {
        setSelectedProductList((prev) => [...prev, selectedProduct]);
      }
      setSelectedProduct({ length: '12m' });
    }
  };

  const incrementProductQuantity = (productData) => {
    const list = selectedProductList.map((prev) => {
      if (prev.product_id === productData.product_id) {
        return {
          ...prev,
          qty: Number(prev.qty) + 1,
        };
      } else {
        return prev;
      }
    });
    setSelectedProductList([...list]);
  };

  const decrementProductQuantity = (productData) => {
    const list = selectedProductList.map((prev) => {
      if (prev.product_id === productData.product_id) {
        return {
          ...prev,
          qty: Number(prev.qty) - 1 === 0 ? 1 : Number(prev.qty) - 1,
        };
      } else {
        return prev;
      }
    });
    setSelectedProductList([...list]);
  };

  const replaceProductQuantity = (productDetails) => {
    const index = selectedProductList.findIndex(
      (prev) => prev.product_id === productDetails.product_id,
    );
    const list = selectedProductList;

    list[index] = productDetails;
    setSelectedProductList([...list]);
  };

  const removeProductFromList = (productDetails) => {
    const list = selectedProductList.filter(
      (prev) => prev.product_id !== productDetails.product_id,
    );
    setSelectedProductList([...list]);
  };

  const handleValueChange = (value, productDetails) => {
    const obj = {
      ...productDetails,
      qty: `${value}`,
    };

    replaceProductQuantity(obj);
  };

  const {
    addedUserList,
    booking_details,
    orderDetails,
    isSecondaryOrder,
    seller_id,
  } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      booking_details: state.bcmOrderReducer.booking_details,
      orderDetails: state.bcmOrderReducer.booking_editorder_details,
      isSecondaryOrder: state.bcmOrderReducer.isSecondaryOrder,
      seller_id: state.bcmOrderReducer.seller_id,
    };
  });
  const confirmProd = () => {
    if (state?.isFromEditOrderDetails) {
      let shipToParty = orderDetails.shipment_details.find(
        (item) =>
          item.ship_to_party_info.company_info.id === state.ship_to_party_details.company_info.id &&
          item.ship_to_party_info.address_info.address.address_line_1 === state.ship_to_party_details.address_info.address.address_line_1 &&
          item.ship_to_party_info.address_info.address.address_line_2 === state.ship_to_party_details.address_info.address.address_line_2 &&
          item.ship_to_party_info.address_info.address.address_line_3 === state.ship_to_party_details.address_info.address.address_line_3 &&
          item.ship_to_party_info.address_info.pincode === state.ship_to_party_details.address_info.pincode
      );
      let existingProductsMap = {};
      if (shipToParty && shipToParty.product_summary_info.length > 0) {
        existingProductsMap = shipToParty.product_summary_info.reduce((acc, product) => {
          acc[product.product_id] = { ...product };
          return acc;
        }, {});
      } else {
        shipToParty = {
          ship_to_party_info: {...state.ship_to_party_details},
          product_summary_keys: [
            "Name",
            "UoM",
            "Delivered",
            "Pending",
            "GST %",
            "UoM Ex GST Price",
            "Total Ex GST"
          ],
          product_summary_info: [],
        };
      }
    
      selectedProductList.forEach((newProduct) => {
        const productId = newProduct.product_id;
        if (existingProductsMap[productId]) {
          if (existingProductsMap[productId].order_product_delivery_id) {
            existingProductsMap[productId] = {
              ...existingProductsMap[productId],
              operation_type: OperationType['UPDATE'],
              pending: {
                ...existingProductsMap[productId].pending,
                quantity_in_metric_ton:
                  Number(existingProductsMap[productId].pending.quantity_in_metric_ton) +
                  Number(newProduct.qty),
              },
            };
          } else {
            existingProductsMap[productId] = {
              ...existingProductsMap[productId],
              pending: {
                ...existingProductsMap[productId].pending,
                quantity_in_metric_ton:
                  Number(existingProductsMap[productId].pending.quantity_in_metric_ton) +
                  Number(newProduct.qty),
              },
            };
          }
        } else {
          existingProductsMap[productId] = {
            ...newProduct,
            name: newProduct.product_name,
            remark: newProduct.remarks,
            pending: {
              quantity_in_metric_ton: Number(newProduct.qty),
              multiplier: newProduct.meta_data.multiplier,
              unit: newProduct.meta_data.unit,
            },
            price_info: {
              price: Number(newProduct.current_price_per_unit),
              unit: 'Rs.',
            },
            delivered: {
              quantity_in_bags: 0,
              quantity_in_metric_ton: 0,
              multiplier: newProduct.meta_data.multiplier,
              quantity: 0,
              unit: 'Ton',
            },
          };
        }
      });
      dispatch({
        type: 'ADD_PRODUCT_EDIT_PO_BOOKING_DETAILS',
        data: {
          ...shipToParty,
          product_summary_info: Object.values(existingProductsMap),
        },
      });
      navigate(-1);
    } else {
      const user = addedUserList[state?.index];

      if (Object.keys(totalCost).length > 0) {
        user.totalCost = totalCost;
      }
      if (user.products && user.products.length > 0) {
        selectedProductList.forEach((newProduct) => {
          const existingProduct = user.products.find(
            (product) => product.product_id === newProduct.product_id,
          );

          if (existingProduct) {
            existingProduct.qty =
              Number(existingProduct.qty) + Number(newProduct.qty);
          } else {
            user.products.push(newProduct);
          }
        });
      } else {
        user.products = [...selectedProductList];
      }
      const list = [...addedUserList];
      list.splice(state?.index, 1, user);

      dispatch({
        type: 'SET_USER_LIST',
        data: list,
      });

      navigate('/order-booking/selected-ship-to-party-list');
    }
  };

  const getTotalCost = async () => {
    if (selectedProductList.length === 0) return;

    const payload = {
      order_products: selectedProductList.map((vv) => ({
        product_id: vv.product_id,
        quantity: {
          quantity_in_metric_ton: vv.qty,
        },
      })),
      seller_id: booking_details.seller_company_id,
      order_booking_id: booking_details.booking_id,
      requested_district_id: addedUserList[state?.index]?.delivery_district_id,
    };

    const { data, error, message } = await getOrderCostAction(payload);

    if (!error) {
      setTotalCost(data);
    } else {
      return toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    // getTotalCost();
  }, [selectedProductList]);

  const getAllSkuValues = async () => {
    const { data, error, response } = await getSkuDetails(
      seller_id || booking_details.seller_company_id,
      skuData,
    );

    if (!error) {
      if (
        data.manufacturer_industry_type === manufacturer_company_type['STEEL']
      ) {
        setIsSteelCompany(true);
        setSelectedProduct((prev) => ({
          ...prev,
          length: '12m',
        }));
        data.details.forEach((item) => {
          if (item.sku_key === skuKeys['GRADE']) {
            item.sku_value_details.forEach((vv) => {
              if (vv.is_default)
                setSteelProdFilters((prev) => ({
                  ...prev,
                  GRADE: vv.sku_value_id,
                }));
            });
            setSkuGrades(item.sku_value_details);
          } else if (item.sku_key === skuKeys['FORM_TYPE']) {
            item.sku_value_details.forEach((vv) => {
              if (vv.is_default)
                setSteelProdFilters((prev) => ({
                  ...prev,
                  FORM_TYPE: vv.sku_value_id,
                }));
            });
            setSkuFormTypes(item.sku_value_details);
          }
        });
      }
    } else {
    }
  };

  useEffect(() => {
    getAllSkuValues();
  }, []);

  const getProducts = async () => {
    let payload = {
      sku_value_id: [8, 9],
    };

    if (isSteelCompany) {
      const temp = Object.keys(steelProdFilters);
      payload = {
        sku_value_id: temp.map((vv) => steelProdFilters[vv]),
      };
    }

    const { data, error, response } = await GetProductsWithSkuDetails(payload);
    if (!error) {
      setProductList(data);
    }
  };

  const getTotalQty = () => {
    return selectedProductList.reduce((acc, item) => {
      return acc + Number(item.qty);
    }, 0);
  };

  useEffect(() => {
    if (isSteelCompany && steelProdFilters.FORM_TYPE && steelProdFilters.GRADE)
      getProducts();
  }, [steelProdFilters]);

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '5rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
          paddingBottom: '2rem',
        }}
      >
        <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
          <Typography
            variant='h6'
            gutterBottom
          >
            Select Sub Category
          </Typography>
          <Grid
            container
            spacing={1}
          >
            {skuGrades.map((grade, index) => (
              <Grid
                item
                key={index}
              >
                <Button
                  variant='outlined'
                  sx={{
                    color:
                      grade.sku_value_id === steelProdFilters.GRADE
                        ? '#F49D3F'
                        : 'black',
                    borderColor:
                      grade.sku_value_id === steelProdFilters.GRADE
                        ? '#F49D3F'
                        : 'black',
                  }}
                  onClick={() =>
                    setSteelProdFilters((prev) => ({
                      ...prev,
                      GRADE: grade.sku_value_id,
                    }))
                  }
                >
                  {grade.sku_value}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Paper>
        <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
          <Typography
            variant='h6'
            gutterBottom
          >
            Select Form Type
          </Typography>
          <Grid
            container
            spacing={1}
          >
            {skuFormTypes.map((form, index) => (
              <Grid
                item
                key={index}
              >
                <Button
                  variant='outlined'
                  sx={{
                    color:
                      form.sku_value_id === steelProdFilters.FORM_TYPE
                        ? '#F49D3F'
                        : 'black',
                    borderColor:
                      form.sku_value_id === steelProdFilters.FORM_TYPE
                        ? '#F49D3F'
                        : 'black',
                  }}
                  onClick={() =>
                    setSteelProdFilters((prev) => ({
                      ...prev,
                      FORM_TYPE: form.sku_value_id,
                    }))
                  }
                >
                  {form.sku_value}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Paper>      
        <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
          <Typography
            variant='h6'
            gutterBottom
          >
            Select Product
          </Typography>
          <Grid
            container
            spacing={1}
          >
            {productList.map((product, index) => (
              <Grid
                item
                key={index}
              >
                <Button
                  variant='outlined'
                  sx={{
                    color:
                      selectedProduct?.product_id === product.product_id
                        ? '#F49D3F'
                        : 'black',
                    borderColor:
                      selectedProduct?.product_id === product.product_id
                        ? '#F49D3F'
                        : 'black',
                  }}
                  onClick={() =>
                    setSelectedProduct((prev) => ({
                      ...product,
                      length: prev.length,
                    }))
                  }
                >
                  {product.product_name}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Paper>
        <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
          <Typography
            variant='h6'
            gutterBottom
          >
            Quantity Details
          </Typography>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={3}
            >
              <TextField
                fullWidth
                label='Length'
                variant='outlined'
                defaultValue={
                  selectedProduct?.length ? selectedProduct?.length : '12m'
                }
                value={selectedProduct?.length}
                onChange={(e) =>
                  setSelectedProduct({
                    ...selectedProduct,
                    length: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
            >
              <TextField
                fullWidth
                defaultValue={0}
                label='Quantity'
                variant='outlined'
                onChange={(e) => {
                  setSelectedProduct({
                    ...selectedProduct,
                    qty: e.target.value,
                  });
                }}
                value={selectedProduct.qty ?? ''}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
            >
              <TextField
                fullWidth
                label='Remarks'
                variant='outlined'
                onChange={(e) =>
                  setSelectedProduct({
                    ...selectedProduct,
                    remarks: e.target.value,
                  })
                }
                value={selectedProduct?.remarks ?? ''}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={3}
            >
              <Button
                variant='contained'
                color='primary'
                fullWidth
                onClick={handleAdd}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Paper>
        {selectedProductList && selectedProductList.length > 0 && (
          <>
            <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
              <Typography
                variant='h6'
                gutterBottom
              >
                Product Summary
              </Typography>
              <TableContainer component={Paper}>
                <Table aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell align={'center'}>#</TableCell>
                      <TableCell align={'center'}>Product Name</TableCell>
                      <TableCell align={'center'}>Quantity</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedProductList.map((product, index) => (
                      <TableRow key={product.product_id}>
                        <TableCell align={'center'}>{index + 1}</TableCell>
                        <TableCell align={'center'}>
                          <MouseOverPopover
                            text={product.product_name}
                            popOverText={product.remarks}
                          />
                        </TableCell>
                        <TableCell align={'center'}>
                          <Stack direction={'row'}>
                            <Grid
                              container
                              justifyContent='flex-end'
                            >
                              <AddRemoveQty
                                quantity={product.qty}
                                onIncreasePress={() =>
                                  incrementProductQuantity(product)
                                }
                                onReducePress={() =>
                                  decrementProductQuantity(product)
                                }
                                onTextChange={(e) =>
                                  handleValueChange(e, product)
                                }
                              />
                            </Grid>

                            <Grid
                              container
                              justifyContent='flex-end'
                              sx={{ width: '60%' }}
                            >
                              <Tooltip title='Discard'>
                                <IconButton
                                  onClick={() => removeProductFromList(product)}
                                >
                                  <Delete sx={{ color: '#FF0000' }} />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell
                        sx={{ fontWeight: 'bold' }}
                        colSpan={2}
                        align={'center'}
                      >
                        Total
                      </TableCell>
                      <TableCell
                        align={'center'}
                        sx={{ fontWeight: 'bold' }}
                      >{`${getTotalQty()} ${
                        selectedProductList[0]?.meta_data?.unit
                      }`}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                variant='contained'
                color='primary'
                sx={{ width: '10rem', fontWeight: 'bold' }}
                onClick={() => confirmProd()}
              >
                Confirm
              </Button>
            </Box>
          </>
        )}
      </Container>
    </>
  );
};

export default AddProduct;
